(function () {
	'use strict';

	var MobTables = (function() {

		var $dataList	= $('.data-list'),
			$rows		= $dataList.find('tr'),
			$ths		= $dataList.find('th'),
			colHeads = [],
			isMobileMode,

		init = function (isMobile) {
			isMobileMode = isMobile;

			if (!isMobileMode) {
				setupTableRowClick();
				return;
			}
			// get the text out of the THs to use when labeling info
			$ths.each( function(){
				colHeads.push( $(this).text() );
			});

			// process each row & add reveal behaviours
			$rows.each(processRow);
		},

		processRow = function() {

			// for each row in the table, chop up the non-essential data to be shown on click
			var frag = '<div class="more">';

			$(this).find('td').each( function( i ){
				if (!$(this).hasClass('mob-show') && !$(this).hasClass('mob-hide')) {
					var content = $(this).text();
					if ($(this).attr('data-pp-render-html') === 'true') {
						content = $(this).html();
					}

					var wrapperClass = '';
					if ($(this).attr('data-pp-wrapper-class')) {
						wrapperClass = ' class="' + $(this).attr('data-pp-wrapper-class') + '"';
					}

					var wrapperElement = '<span' + wrapperClass + '>';
					var name = colHeads[i] ? '<strong>' + colHeads[i] + ':</strong> ' : '';
					frag += wrapperElement + name + content + '</span>';
				}
			});

			frag += '</div><span class="reveal-ind">o</span>';
			$(this).append(frag);

			$(this).on('click', function (e) {
				/*jshint ignore:start */
				if ($(e.target).attr('data-no-propagate') === 'true') {
					e.stopPropagation();
				} else {
					($(this).hasClass('show-more')) ? $(this).removeClass('show-more') : $(this).addClass('show-more');
				}
				/*jshint ignore:end */
			});

		},

		newData = function( _obj ) {
			if (!isMobileMode)
				return;

			_obj.each( processRow );
		};

		var setupTableRowClick = function () {
			$(document).on('keydown','[data-navigate-on-action]',
					function(e) {
						if (e.keyCode === 13 || e.keyCode === 32) { //if enter or space
							e.stopPropagation();
							e.preventDefault();
							window.document.location = $(this).data('navigate-on-action-url');
						}
					});

			$(document).on('click', '[data-navigate-on-action]',
					function () {
						window.document.location = $(this).data('navigate-on-action-url');
					});
		};

		return { init: init, newData: newData };
	}());

	$(document).ready(function(){
		MobTables.init(window.pushpay.isMobile);
	});

	window.mobileTablesUi = MobTables;

}());
